/**
 * 自オリジンへの HEAD の Date ヘッダをサーバー時刻とし、往復の中間時点の端末時刻との差を取る。
 * Date ヘッダは秒単位なので、誤差は往復時間の非対称と合わせて 1〜2 秒程度になる。
 */
const measureServerTimeOffsetMs = async (): Promise<number> => {
  const begin = Date.now();
  const response = await fetch(window.location.origin, {
    method: "HEAD",
    cache: "no-store",
  });
  const end = Date.now();
  const serverTime = Date.parse(response.headers.get("Date") ?? "");
  if (Number.isNaN(serverTime)) {
    throw new Error("Date ヘッダからサーバー時刻を読み取れませんでした");
  }
  return serverTime - (begin + end) / 2;
};

let serverTimeOffsetMs: number | null = null;

/**
 * サーバー時刻 − 端末時刻（ミリ秒）
 *
 * 端末の時計はずれていることがあるので、サーバーと時刻を比べる箇所はこの差で補正する。
 * 計測できた値は、ページを開いている間使い回す。最初の計測が終わる前に呼ばれた分は、それぞれが
 * 計測する。計測に失敗したときは 0（端末の時刻をそのまま使う）を返し、次の呼び出しで計測し直す。
 */
export const getServerTimeOffsetMs = async (): Promise<number> => {
  if (serverTimeOffsetMs !== null) return serverTimeOffsetMs;
  try {
    serverTimeOffsetMs = await measureServerTimeOffsetMs();
    return serverTimeOffsetMs;
  } catch (error) {
    console.error(error);
    return 0;
  }
};
